import React from 'react';
import classNames from 'classnames/bind';
import { Button, Text } from '@beef/ui-kit';
import styles from "./styles.module.pcss";
var cn = classNames.bind(styles);
export var Error = function Error(_ref) {
  var onError = _ref.onError;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('error'),
    "data-t-id": "components-Error"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "grey95",
    size: "size4-m",
    tagType: "span"
  }, "\u0427\u0442\u043E-\u0442\u043E \u043F\u043E\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A"), /*#__PURE__*/React.createElement("div", {
    className: cn('error__text')
  }, /*#__PURE__*/React.createElement(Text, {
    color: "grey95",
    size: "size5-r-s",
    tagType: "span"
  }, "\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0431\u0430\u043D\u043D\u0435\u0440")), /*#__PURE__*/React.createElement("div", {
    className: cn('error__btn')
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onError,
    size: "l",
    type: "button",
    variant: "tertiary"
  }, "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C")));
};